import { combineReducers } from '@reduxjs/toolkit';

import { accountReducer as account } from './account.reducer';
import { prizeReducer as prize } from './prize.reducer';
import { taxProfileReducer as tax } from './tax.reducer';
import { configReducer as config } from './config.reducer';
import { legalReducer as legal } from './legal.reducer';
import { payoutReducer as payout } from './payout.reducer';
import { commonReducer as common } from './common.reducer';

const reducers = {
    account,
    prize,
    tax,
    config,
    legal,
    payout,
    common
};

const rootReducer = combineReducers(reducers);

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
